import { render, staticRenderFns } from "./GridMangeDetail.vue?vue&type=template&id=66af30c1&scoped=true"
import script from "./GridMangeDetail.vue?vue&type=script&lang=js"
export * from "./GridMangeDetail.vue?vue&type=script&lang=js"
import style0 from "./GridMangeDetail.vue?vue&type=style&index=0&id=66af30c1&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66af30c1",
  null
  
)

export default component.exports